import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loginCheck } from '../../auth/auth';
import HeaderMain from '../../components/HeaderMain/HeaderMain';
import HeaderMobile from '../../components/HeaderMobile/HeaderMobile';
import Footer from '../../components/Footer/Footer';
import styles from './Main.module.scss';
import hospitalIcon from '../../assets/hospitalReservation/hospitalIcon.png';
import starIcon from '../../assets/hospitalReservation/starIcon.png';
import plasticSurgeryIcon from '../../assets/hospitalReservation/plasticSurgeryIcon.png';
import dermatologyIcon from '../../assets/hospitalReservation/dermatologyIcon.png';
import orientalMedicineIcon from '../../assets/hospitalReservation/orientalMedicineIcon.png';

function Main() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<string>('');
  const [isMobile, setIsMobile] = useState(false);
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    if (!loginCheck()) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [i18n]);

  const renderMainContent = () => {
    if (selectedTab === '') {
      return (
        <div className={styles.mainContent}>
          <div className={styles.leftPanel}>
            <h1>
              {i18n
                .t("main.leftPanel.title")
                .split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </h1>
            <br />
            <span>{i18n.t('main.leftPanel.subtitle')}</span>
            <img
              src={hospitalIcon}
              alt="Hospital Illustration"
              className={styles.hospitalImage}
            />
          </div>
          <div className={styles.rightPanel}>
            <div 
              className={styles.banner}
              onClick={() =>
                navigate('/treatment-list', { state: { category: '전체보기' } })
              }
            >
              <img src={starIcon} alt="Banner" className={styles.starImage} />
              <p className={styles.bannerText}>
                {i18n.t('main.rightPanel.bannerText')}
              </p>
            </div>
            <div className={styles.cardContainer}>
              {/* <div
                className={styles.card}
                onClick={() =>
                  navigate('/treatment-list', { state: { category: '성형외과' } })
                }
              >
                <div className={styles.cardContent}>
                  <h3>{i18n.t('main.rightPanel.cards.plasticSurgery')}</h3>
                  <span className={styles.arrowIcon}>›</span>
                </div>
                <img src={plasticSurgeryIcon} alt="Plastic Surgery" />
              </div>
              <div
                className={styles.card}
                onClick={() =>
                  navigate('/treatment-list', { state: { category: '피부과' } })
                }
              >
                <div className={styles.cardContent}>
                  <h3>{i18n.t('main.rightPanel.cards.dermatology')}</h3>
                  <span className={styles.arrowIcon}>›</span>
                </div>
                <img src={dermatologyIcon} alt="Dermatology" />
              </div> */}
              <div
                className={styles.wideCard}
                onClick={() =>
                  navigate('/treatment-list', { state: { category: '성형외과' } })
                }
              >
                <div className={styles.cardContent}>
                  <h3>{i18n.t('main.rightPanel.cards.plasticSurgery')}</h3>
                  <span className={styles.arrowIcon}>›</span>
                  <span className={styles.bestBadge}>
                    {i18n.t('main.rightPanel.cards.bestBadge')}
                  </span>
                </div>
                <p className="orientalMedicineDescription">
                  {i18n.t('main.rightPanel.cards.plasticSurgeryDescription')}
                </p>
                <img src={plasticSurgeryIcon} alt="Plastic sSurgery" />
              </div>
              <div
                className={styles.wideCard}
                onClick={() =>
                  navigate('/treatment-list', { state: { category: '피부과' } })
                }
              >
                <div className={styles.cardContent}>
                  <h3>{i18n.t('main.rightPanel.cards.dermatology')}</h3>
                  <span className={styles.arrowIcon}>›</span>
                  {/* <span className={styles.bestBadge}>
                    {i18n.t('main.rightPanel.cards.bestBadge')}
                  </span> */}
                </div>
                <p className="orientalMedicineDescription">
                  {i18n.t('main.rightPanel.cards.orientalMedicineDescription')}
                </p>
                <img src={dermatologyIcon} alt="Dermatology" />
              </div>
              {/* <div
                className={styles.wideCard}
                onClick={() =>
                  navigate('/treatment-list', { state: { category: '한방' } })
                }
              >
                <div className={styles.cardContent}>
                  <h3>{i18n.t('main.rightPanel.cards.orientalMedicine')}</h3>
                  <span className={styles.arrowIcon}>›</span>
                  <span className={styles.bestBadge}>
                    {i18n.t('main.rightPanel.cards.bestBadge')}
                  </span>
                </div>
                <p className="orientalMedicineDescription">
                  {i18n.t('main.rightPanel.cards.orientalMedicineDescription')}
                </p>
                <img src={orientalMedicineIcon} alt="Oriental Medicine" />
              </div> */}
            </div>
          </div>
        </div>
      );
    } else if (selectedTab === 'myReservation') {
      return (
        <div className={styles.mainContent}>
          <h1>내 예약 확인하기 기능은 준비 중입니다.</h1>
        </div>
      );
    }
  };

  return (
    <div className={styles.Main}>
      {isMobile ? (
        <HeaderMobile />
      ) : (
        <HeaderMain selectedTab={selectedTab} onTabChange={setSelectedTab} />
      )}
      {renderMainContent()}
      <Footer />
    </div>
  );
}

export default Main;
